import React from "react";
import { RubriqueBlock } from "./Rubrique";

export default function Demarches() {
  return (
    <div className="container">
      <h1>Démarches administratives</h1>
      <p className="muted mb-3">Les services et formulaires utiles au quotidien.</p>
      <RubriqueBlock cle="administratif" />
      <RubriqueBlock cle="urgences" />
    </div>
  );
}
